import deFormatText from "./deformat-text";
import { SECTION_TYPES } from "./constant";

const formBuilderConversion = (data: any) => {
  const backend_output = <any>[];

  const addSectionInBackendOutput = (section: any) => {
    if (section?.section_type === SECTION_TYPES.FORM_SWITCH_SECTION) {
      backend_output.push({
        is_section_field: true,
        field_type: section?.field_type,
        label: section?.label,
        section_type: section?.section_type,
        form_switcher_label: section?.form_switcher_label,
        form_switcher_name: section?.form_switcher_name,
        switcher_forms: section?.switcher_forms,
        is_accordion: section?.is_accordion,
        section_name: section?.label || '',
        name: section?.label || '',
        section_order: section?.section_order || 0,
        placeholder: '',
        validation: [],
      })
    }
  }

  data.tab &&
    data.tab.forEach((tab: any) => {
      const tab_name = tab.title;
      const tab_order = tab.tab_order;

      tab.data?.forEach((section: any) => {
        addSectionInBackendOutput(section)
        const section_name = section.label;
        const is_accordion = section.is_accordion;

        section.members?.forEach((member: any) => {
          const validationArray = [];
          if (member.field_type !== "info") {
            validationArray.push(
              {
                type: "required",
                value: member.is_required,
                msg_en: "This Field is required",
              },
              {
                type: "unique",
                value: member.is_unique,
                msg_en: "This Field is unique",
              },
            );
          }

          if (member.field_type === "text") {
            validationArray.push(
              {
                type: "min_length",
                value: member.min_length ?? 1,
                msg_en: `The minimum length should be ${member.min_length}`,
              },
              {
                type: "max_length",
                value: member.max_length || member?.is_multiline ? 1000 : 255 ,
                msg_en: `The maximum length should be ${member.max_length}`,
              },
            );
          } else if (member.field_type === "number") {
            validationArray.push(
              {
                type: "min_val",
                value: member.min_length ?? 1,
                msg_en: `The minimum value should be ${member.min_length}`,
              },
              {
                type: "max_val",
                value: member.max_length ?? 10000,
                msg_en: `The maximum value should be ${member.max_length}`,
              },
            );
          } else if (member.field_type === "date") {
            validationArray.push(
              {
                type: "is_future_dates_allowed",
                value: member.is_future_dates_allowed ?? false,
                msg_en: "",
              },
              {
                type: "is_past_dates_allowed",
                value: member.is_past_dates_allowed ?? false,
                msg_en: "",
              },
            );
          } else if (
            member.field_type === "image" ||
            member.field_type === "file"
          ) {
            validationArray.push({
              type: "max_file_size",
              value:
                member.max_size && member.max_size > 2
                  ? Number(member.max_size)
                  : 20,
              msg_en: `Max size of file should be ${member.max_size}`,
            });
          }

          const outputObj = {
            ...member,
            tab_name,
            section_name: section_name || '',
            tab_order,
            section_order: member.section_order || 0,
            label: member.label,
            name:  member?.name || deFormatText(member.label) || '',
            placeholder: member.placeholder,
            field_type:
              member.field_type === "file" ? "media" : member.field_type,
            default_value: member.default_value,
            ...(member.option &&
              member?.field_type === "time" && { time_format: member.option }),
            ...(member.option &&
              member?.field_type === "currency" && { currency: member.option }),
            table_columns: member.table_columns?.map(col => member?.is_new ? `${member?.table}.${col.accessorKey}` : col.accessorKey),
            field_properties: {
              ...(member.is_multiline !== undefined && {
                is_multiline: member.is_multiline,
              }),
              is_accordion,
              ...(member.is_negative !== undefined && {
                is_negative: member.is_negative,
              }),
              ...(member.float_step && {
                float_step: Number(member.float_step),
              }),
              ...(member.options && { options: member.options }),
              ...(member.is_multiselect !== undefined && {
                is_multiselect: member.is_multiselect,
              }),
              ...(member.title !== undefined && {
                title: member.title,
              }),
              ...(member.title_position !== undefined && {
                title_position: member.title_position,
              }),
              ...(member?.table_columns !== undefined && {
                table: member?.table || 'custom', 
                table_columns: member.table_columns?.map(col => member?.is_new ? `${member?.table}.${col.accessorKey}` : col.accessorKey),
              }),
              ...(member?.field_properties?.apiType !== undefined && {
                apiType: member.field_properties.apiType,
              }),
              ...(member?.field_properties?.customeFilter !== undefined && {
                customeFilter: member.field_properties.customeFilter,
              }),
              ...(member?.field_properties?.attributes !== undefined && {
                attributes: member.field_properties.attributes,
              }),

            },
            validation: validationArray,
          };

          if (outputObj) {
            backend_output.push(outputObj);
          }
        });
      });
    });

  data.section &&
    data.section.forEach((section: any) => {
      addSectionInBackendOutput(section)
      const section_name = section.label;
      const is_accordion = section.is_accordion;

      section.members.forEach((member: any) => {
        const validationArray = [];
        if (member.field_type !== "info") {
          validationArray.push(
            {
              type: "required",
              value: member.is_required ?? false,
              msg_en: "This Field is required",
            },
            {
              type: "unique",
              value: member.is_unique ?? false,
              msg_en: "This Field is unique",
            },
          );
        }
        if (member.field_type === "text") {
          validationArray.push(
            {
              type: "min_length",
              value: member.min_length ?? 1,
              msg_en: `The minimum length should be ${member.min_length}`,
            },
            {
              type: "max_length",
              value: member.max_length || member?.is_multiline ? 1000 : 255 ,
              msg_en: `The maximum length should be ${member.max_length}`,
            },
          );
        } else if (member.field_type === "number") {
          validationArray.push(
            {
              type: "min_val",
              value: member.min_length ?? 1,
              msg_en: `The minimum value should be ${member.min_length}`,
            },
            {
              type: "max_val",
              value: member.max_length ?? 10000,
              msg_en: `The maximum value should be ${member.max_length}`,
            },
          );
        } else if (member.field_type === "date") {
          validationArray.push(
            {
              type: "is_future_dates_allowed",
              value: member.is_future_dates_allowed ?? false,
              msg_en: "",
            },
            {
              type: "is_past_dates_allowed",
              value: member.is_past_dates_allowed ?? false,
              msg_en: "",
            },
          );
        } else if (
          member.field_type === "image" ||
          member.field_type === "file"
        ) {
          validationArray.push({
            type: "max_file_size",
            value:
              member.max_size && member.max_size > 2
                ? Number(member.max_size)
                : 20,
            msg_en: `Max size of file should be ${member.max_size}`,
          });
        }

        const outputObj = {
          ...member,
          section_order: member.section_order,
          section_name,
          label: member.label,
          name:  member?.name || deFormatText(member.label),
          placeholder: member.placeholder,
          field_type:
            member.field_type === "file" ? "media" : member.field_type,
          default_value: member.default_value,
          ...(member.option &&
            member?.field_type === "time" && { time_format: member.option }),
          ...(member.option &&
            member?.field_type === "currency" && { currency: member.option }),
          table_columns: member.table_columns?.map(col => member?.is_new ? `${member?.table}.${col.accessorKey}` : col.accessorKey),
          field_properties: {
            ...(member.is_multiline !== undefined && {
              is_multiline: member.is_multiline,
            }),
            is_accordion,
            ...(member.is_negative !== undefined && {
              is_negative: member.is_negative,
            }),
            ...(member.float_step && {
              float_step: Number(member.float_step),
            }),
            ...(member.options && { options: member.options }),
            ...(member.is_multiselect !== undefined && {
              is_multiselect: member.is_multiselect,
            }),
            ...(member.title !== undefined && {
              title: member.title,
            }),
            ...(member.title_position !== undefined && {
              title_position: member.title_position,
            }),
            ...(member?.table_columns !== undefined && {
              table: member?.table || 'custom', 
              table_columns: member.table_columns?.map(col => member?.is_new ? `${member?.table}.${col.accessorKey}` : col.accessorKey),
            }),
            ...(member?.field_properties?.apiType !== undefined && {
              apiType: member.field_properties.apiType,
            }),
            ...(member?.field_properties?.customeFilter !== undefined && {
              customeFilter: member.field_properties.customeFilter,
            }),
            ...(member?.field_properties?.attributes !== undefined && {
              attributes: member.field_properties.attributes,
            }),
          },
          validation: validationArray,
        };

        if (outputObj) {
          backend_output.push(outputObj);
        }
      });
    });
  return backend_output;
};


export { formBuilderConversion };
export default formBuilderConversion;
